import { Container, UpBtn, DownBtn, AmountNum } from './Amount.parts';
import React from 'react';

type InputType = {
  amount: number;
  setAmount: (value: (prev: number) => number) => void;
};

export const Amount = ({ amount, setAmount }: InputType) => {

  return (
    <Container>
        <DownBtn onClick={() => setAmount((prev) => prev - 1)}  disabled={amount <= 1}/>
        <AmountNum>{amount}</AmountNum>
        <UpBtn onClick={() => setAmount((prev) => prev + 1)} />
    </Container>
  );
};
